export default {
  //rooturl: "http://localhost:3001/kugiapi/",
  rooturl: "https://gold.big.go.id:8080/kugiapi/",
  // rooturl: "http://18.223.168.25:8080/kugiapi/",
//rooturl: "http://192.168.210.112:8080/kugiapi/",
//rooturl: "http://10.10.170.142:8080/kugiapi/",
  //rooturl: "https://gold.big.go.id:8080/kugiapi/",
  //rooturl: "http://35.198.225.7:8080/kugiapi-0.0.1-SNAPSHOT/",
  //rooturl: "http://www.mocky.io/v2/5d187f65300000ea238beaf9/",
  //apikey: "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJmZXJuaWF3YW5AcmVkYml0LmNvLmlkIiwiZXhwIjoxNTkyNDMxMDA1fQ.tRIyIaM_u8JNqde_SMFNfBQAyJxmUOfaHXVuqaeLHat6e3MbTCyYOF5sgOKLGd6gwcfdaiqG6RUEv99N20Y_lw"
  apikey: "Bearer ",
};
